<template>
  <div>
    <VTextField
      :value="value"
      class="preset-form__search-field white"
      outlined
      dense
      hide-details
      autocomplete="off"
      :placeholder="$t('search')"
      append-icon="mdi-magnify"
      type="text"
      @input="update"
    />
  </div>
</template>
<script>
export default {
  name: 'VacancyPresetsSearch',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    update(val) {
      this.$emit('search', val);
    },
  },
};
</script>

<i18n locale="ru" lang="yaml">
  search: Поиск
</i18n>

<i18n locale="en" lang="yaml">
  search: Search
</i18n>
